import BASE_URL from "components/BaseUrl/apiConfig";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";

const AddDocumentCategory = () => {
  //   const isLargeDevice = useMediaQuery({ minWidth: 1024 });

  const history = useHistory();
  const userNameInputRef = useRef(null);
  const location = useLocation();
  const [formData, setFormData] = useState({
    documentCategoryId: "",
    documentCategoryname: "",
    defaultText: "",
  });
  const [validationMessages, setValidationErrors] = useState({
    documentCategoryname: "",
  });
  const [errors, setErrors] = useState({});
  const [expenseTypeData, setExpenseTypeData] = useState(null);

  //Get Useid form localStorage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }

  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();
  }, []);

  useEffect(() => {
    // Check if data is available in the location state
    if (location.state && location.state.documentCategory) {
      const { documentCategory } = location.state;
      setFormData({
        documentCategoryId: documentCategory.documentCategoryId || "",
        documentCategoryname: documentCategory.name || "",
        defaultText: documentCategory.defaultText,
      });
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the validation error when the user types
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Perform validation logic for each field
    if (formData.documentCategoryname.trim() === "") {
      newErrors.documentCategoryname = "Document Category  is required.";
      isValid = false;
    }

    setValidationErrors(newErrors);
    return isValid;
  };

  const handleAddDocumentCategory = async (e) => {
    e.preventDefault();

    // Validate the form before making the API call
    if (!validateForm()) {
      return;
    }

    try {
      const url =
        location.state && location.state.documentCategory
          ? `${BASE_URL}/api/DocumentCategory/UpdateDocumentCategory`
          : `${BASE_URL}/api/DocumentCategory/InsertDocumentCategory`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          documentCategoryId: formData.documentCategoryId || null, // Include expensedescTypeID if present
          name: formData.documentCategoryname,
          defaulttext: formData.defaultText,
          userId: userId,
        }),
      });

      if (response.ok) {
        history.push("/getAllDocumentCategory");
      } else {
        console.error("Error adding expense type");
      }
    } catch (error) {
      console.error("Error adding expense type:", error);
    }
  };

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto p-4 h-full">
          <div className="flex content-center items-center justify-center h-full">
            <div className="w-full lg:w-9/12 px-4">
              <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div className="rounded-t mb-0 px-6 py-3">
                  <div className="text-center mb-3">
                    <h1 className="text-2xl font-bold">
                      {formData.documentCategoryId
                        ? "Update Category"
                        : "Add New Category"}
                    </h1>
                  </div>
                  {/* <hr className="mt-6 border-b-1 border-blueGray-300" /> */}
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                  <form>
                    <div className="w-full md:flex md:justify-between">
                      <div className="mb-3 md:w-1/2 pr-4">
                        <label
                          htmlFor="documentCategoryname"
                          className="block text-xs font-bold text-gray-700"
                        >
                          Category
                        </label>
                        <input
                          type="text"
                          id="documentCategoryname"
                          name="documentCategoryname"
                          maxLength={30}
                          ref={userNameInputRef}
                          value={formData.documentCategoryname}
                          onChange={handleChange}
                          placeholder="Category "
                          className="mt-1 p-2 border rounded w-full"
                          style={{ width: "285px" }}
                        />
                        {/* here is the code of the expensedescTypeID store in hidden form */}
                        <input
                          type="hidden"
                          id="documentCategoryId"
                          name="documentCategoryId"
                          value={formData.documentCategoryId}
                        />

                        <div className="text-red-500 text-xs mt-1">
                          {validationMessages.documentCategoryname}
                        </div>
                      </div>

                      <div className="mb-3 md:w-1/2 pr-4">
                        <label
                          htmlFor="defaultText"
                          className="block text-xs font-bold text-gray-700"
                        >
                          Default Text
                        </label>
                        <input
                          type="text"
                          id="defaultText"
                          maxLength={70}
                          name="defaultText"
                          value={formData.defaultText}
                          onChange={handleChange}
                          className="mt-1 p-2 border rounded"
                          placeholder="Default Text"
                          style={{ width: "400px" }}
                        />
                      </div>
                    </div>

                    <div className="flex justify-end w-full">
                      <button
                        type="button"
                        title="Back To Document Category List"
                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        onClick={() => history.goBack()}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        onClick={handleAddDocumentCategory}
                        className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                      >
                        {formData.documentCategoryId
                          ? "Update  Category"
                          : "Add New Category"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AddDocumentCategory;
